export default __webpack_public_path__ + "static/media/at_risk.9090be98.svg";